import ObstructionType from '@/enums/ObstructionType';

const ObstructionTypes = [
  {
    key: 1,
    type: ObstructionType.ONCE,
  },
  {
    key: 2,
    type: ObstructionType.ONCE_INDEFINITE,
  },
  {
    key: 3,
    type: ObstructionType.YEARLY,
  },
];

export default ObstructionTypes;
